/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const JobOutcomeNextClearFilters = core.serialization.object({
    label: core.serialization.string().optional(),
    sheetIds: core.serialization.list(core.serialization.string()).optional(),
});
